module.exports = __webpack_public_path__ + "img/financial-area.bcc5f0e8.svg";